import axios from "axios";

export const handleGetSignatureOnRamper = async (search: string): Promise<string> => {
  try {
    const { data: signature } = await axios.post<string>(`${process.env.WIDGET_BASE_URL}/api/sign-url`, JSON.stringify({
      search,
      provider: "onramper",
    }),
    {
      withCredentials: true,
    });

    return signature;
  } catch (error) {
    console.log("errr", error);
    throw new Error("NO sig for you");
  }
};

export const handleGetSignatureMoonPay = async (url: string): Promise<string> => {
  try {
    const originalUrl = new URL(url);

    const {search} = originalUrl;

    const { data: signature } = await axios.post<string>(`${process.env.WIDGET_BASE_URL}/api/sign-url`, JSON.stringify({
      search,
      provider: "moonpay_webwallet",
    }),
    {
      withCredentials: true,
    });

    return signature;
  } catch (error) {
    console.log("errr", error);
    throw new Error("NO sig for you");
  }
};
